import { WebserviceUrl } from "@tm/data/webserviceUrls"
import { CisCustomerResponse, CisShowCustomerRequest } from "@tm/models"
import { ajaxAuth } from "@tm/utils"

function mapCustomer(data: any): CisCustomerResponse | undefined {
    if (!data) {
        return
    }
    return {
        ...data,
        companyName: data.companyName,
        customerName: data.companyNameAddition1,
        account: data.account,
        addresses: data.addresses || [],
        shippingTypes: data.shippingTypes || [],
        notes: data.notes || [],
        salesOutlets: data.salesOutlets || [],
    }
}

export function showCustomer(body: CisShowCustomerRequest) {
    const url = `${WebserviceUrl.CisCustomer}/ShowCustomer`

    return ajaxAuth<{ customer?: CisCustomerResponse }>({ url, body }).then((response) => {
        if (!response) {
            return
        }
        const customer = mapCustomer(response.customer)
        if (!customer) {
            return
        }

        return {
            ...customer,
            requestedCustomerNo: body.customerNo, // In some cases (PV/Neimcke) is the requested customerNo not equals to the real customerNo, but we need to compare the requested one later.
        }
    })
}
